import React, {useEffect, useState} from 'react';

import {AppQrCodeProps} from './AppQrCodeProps'
import {ReactComponent as RefreshIcon} from './refresh_24px.svg';

import './AppQrCodeStyles.scss'
import QRCode from "react-qr-code";
import {DateTime, Duration} from "luxon";
import AppIcon from "../../atoms/AppIcon/AppIcon";
import {DecorativeAppIconProps} from "../../atoms/AppIcon/AppIconProps";
import clsx from "clsx";


const AppQrCode = (props: AppQrCodeProps) => {

    const {
        qrCode,
        className,
        disabled,
        validDate,
        onClick,
        textContent,
        style
    } = props

    const [isMobywatelCodeActive, setIsMobywatelCodeActive] = useState<boolean>(true);
    const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null)


    useEffect(() => {
        if (!validDate) {
            setIsMobywatelCodeActive(true);
            return;
        }
        refresh(validDate);
    }, [validDate])


    // @ts-ignore
    const [timeToCodeExpiresInSeconds, setTimeToCodeExpiresInSeconds] =
        useState<number | null | undefined>()


    const refresh = (validDate: DateTime): void => {
        const now = DateTime.utc();
        if (!validDate) {
            setIsMobywatelCodeActive(false);
            setTimeToCodeExpiresInSeconds(null);
            return;
        }
        let diffInSeconds = validDate.diff(now, "seconds").seconds;
        if (diffInSeconds < 0) {
            setIsMobywatelCodeActive(false);
            setTimeToCodeExpiresInSeconds(null);
            return;
        } else {
            setIsMobywatelCodeActive(true);
            setTimeToCodeExpiresInSeconds(diffInSeconds)
        }

        const id = setInterval(() => {
            setTimeToCodeExpiresInSeconds((prevSeconds) => {
                if (!prevSeconds) {
                    return diffInSeconds
                } else if (prevSeconds >= 1) {
                    return prevSeconds - 1
                } else {
                    setIsMobywatelCodeActive(false);
                    clearInterval(id)
                    return;
                }
            })
        }, 1000)

        setIntervalId(id)
        return;
    }

    const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) {
            return
        } else {
            onClick(e)
        }
    }

    return (
        <div className={clsx('app-qr-code-wrapper', className)} style={style}>
            <div className={`app-qr-code ${!isMobywatelCodeActive ? 'inactive' : ''}`}>
                <QRCode value={qrCode ?? ""}/>
                {
                    !isMobywatelCodeActive && (
                        <button className='app-qr-code-refresh-button'
                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleOnClick(e)}>
                            <AppIcon
                                decorative={true}
                                icon={RefreshIcon}
                                width='24px'
                                height='24px'
                                color={'#5f134'}/>
                            <span>Odśwież</span>
                            <span>kod QR</span>
                        </button>
                    )
                }
            </div>
            {
                isMobywatelCodeActive ? (
                    timeToCodeExpiresInSeconds === undefined || timeToCodeExpiresInSeconds === null ? null :
                        <span className="app-qr-code-countdown-text">
            {
                (textContent('mObywatelIdentityPage.desktop.copyCodeHeader') || "Kod QR wygaśnie za ")
            }
                            {Duration.fromObject({seconds: timeToCodeExpiresInSeconds}).toFormat('m:ss')}</span>
                ) : (
                    <span className="app-qr-code-countdown-text">
            {
                (textContent('mObywatelIdentityPage.desktop.codeExpired')?.trim() || "Kod QR wygasł")
            }
        </span>
                )
            }
        </div>
    )
}

export default AppQrCode